import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const customerListState = (state: AppState) => state.contactsAndOrganizations.customers.customerList;

export const customerListItemsSelector = createSelector(customerListState, state => state.items);
export const customerListRequestingSelector = createSelector(customerListState, state => state.requesting);
